<template>
  <swiper
    :modules="modules"
    :thumbs="{ swiper: thumbsSwiper }"
    :style="{
      '--swiper-navigation-color': '#fff',
      '--swiper-pagination-color': '#fff',
    }"
    :navigation="true"
    @slideChange="updateSlide">
    <swiper-slide v-for="(image,index) in images" :key="image.id">
      <a :href="image.largeSrc" @click.prevent="startLargeCarousel(index)" class="tw-bg-white/80 hover:tw-bg-white/100 tw-absolute tw-px-2 tw-pt-1 tw-rounded-full tw-right-[10px] tw-top-[10px] tw-op tw-border-0" id="property-magnifying-glass">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-5 tw-h-5 tw-mt-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>

      </a>
      <img :src="image.src" />
      <p class="image-caption">
        <span>{{ image.caption }}</span>
        <span> {{ currentSlide }} of {{ totalSlides }}</span>
      </p>
    </swiper-slide>
  </swiper>
  <swiper @swiper="setThumbsSwiper" watch-slides-progress :modules="modules" :grabCursor="true" :spaceBetween="0" :slidesPerView="4" class="thumbsSlider" v-if="images.length > 1">
    <swiper-slide v-for="image in images" :key="image.id">
      <img :src="image.src" />
    </swiper-slide>
  </swiper>

  <large-image-carousel :images="images" :isOpen="showLargeGallery" @close="showLargeGallery=false" :startingIndex="largeGalleryStartingIndex"></large-image-carousel>


</template>

<script setup>
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import LargeImageCarousel from "./LargeImageCarousel.vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation, Thumbs } from "swiper/modules";

const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
});

const emits = defineEmits(["start-large-carousel"]);
const thumbsSwiper = ref(null);

const currentSlide = ref(1);
const totalSlides = ref(props.images.length);

const updateSlide = (swiper) => {
  currentSlide.value = swiper.activeIndex + 1;
  totalSlides.value = swiper.slides.length;
};
const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};

const showLargeGallery = ref(false);
const largeGalleryStartingIndex = ref(0);

const startLargeCarousel = (index) => {
  showLargeGallery.value=true;
  largeGalleryStartingIndex.value=index;
};

const modules = [Navigation, Thumbs];
</script>

<style scoped>
.thumbsSlider .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.thumbsSlider .swiper-slide-thumb-active {
  opacity: 1;
}
</style>
